import React from 'react';
import tinycolor from 'tinycolor2';

export const drawCircleSvg = (x, y, size, strokeColor, fillColor = 'none') => (
  <circle cx={x} cy={y} r={size / 2} stroke={strokeColor} fill={fillColor} />
);

export const drawSquareSvg = (x, y, size, strokeColor, fillColor = 'none') => (
  <rect x={x - size / 2} y={y - size / 2} width={size} height={size} stroke={strokeColor} fill={fillColor} />
);

export const drawTriangleSvg = (x, y, size, strokeColor, fillColor = 'none') => {
  const points = [`${x},${y - size / 2}`, `${x + size / 2},${y + size / 2}`, `${x - size / 2},${y + size / 2}`].join(' ');
  return <polygon points={points} stroke={strokeColor} fill={fillColor} />;
};

export const drawStarSvg = (x, y, size, strokeColor, fillColor = 'none') => {
  const outerRadius = size / 2;
  const innerRadius = outerRadius / 2.5;
  const points = 5;
  const starPoints = [];
  for (let i = 0; i < points; i++) {
    const angle = (i * 2 * Math.PI) / points - Math.PI / 2;
    const outerX = x + outerRadius * Math.cos(angle);
    const outerY = y + outerRadius * Math.sin(angle);
    starPoints.push(`${outerX},${outerY}`);
    const innerAngle = angle + Math.PI / points;
    const innerX = x + innerRadius * Math.cos(innerAngle);
    const innerY = y + innerRadius * Math.sin(innerAngle);
    starPoints.push(`${innerX},${innerY}`);
  }
  return <polygon points={starPoints.join(' ')} stroke={strokeColor} fill={fillColor} />;
};

export const drawDiamondSvg = (x, y, size, strokeColor, fillColor = 'none') => {
  const points = [`${x},${y - size / 2}`, `${x + size / 2},${y}`, `${x},${y + size / 2}`, `${x - size / 2},${y}`].join(' ');
  return <polygon points={points} stroke={strokeColor} fill={fillColor} />;
};

export const drawXSvg = (x, y, size, strokeColor) => (
  <>
    <line x1={x - size / 2} y1={y - size / 2} x2={x + size / 2} y2={y + size / 2} stroke={strokeColor} />
    <line x1={x + size / 2} y1={y - size / 2} x2={x - size / 2} y2={y + size / 2} stroke={strokeColor} />
  </>
);

export const drawHexagonSvg = (x, y, size, strokeColor, fillColor = 'none') => {
  const points = Array.from({ length: 6 }, (_, i) => {
    const angle = (i * 2 * Math.PI) / 6 - Math.PI / 2;
    const px = x + (size / 2) * Math.cos(angle);
    const py = y + (size / 2) * Math.sin(angle);
    return `${px},${py}`;
  }).join(' ');
  return <polygon points={points} stroke={strokeColor} fill={fillColor} />;
};

export const drawPentagonSvg = (x, y, size, strokeColor, fillColor = 'none') => {
  const points = Array.from({ length: 5 }, (_, i) => {
    const angle = (i * 2 * Math.PI) / 5 - Math.PI / 2;
    const px = x + (size / 2) * Math.cos(angle);
    const py = y + (size / 2) * Math.sin(angle);
    return `${px},${py}`;
  }).join(' ');
  return <polygon points={points} stroke={strokeColor} fill={fillColor} />;
};

export const drawCrossSvg = (x, y, size, strokeColor, fillColor = 'none') => (
  <>
    <rect x={x - size / 10} y={y - size / 2} width={size / 5} height={size} stroke={strokeColor} fill={fillColor} />
    <rect x={x - size / 2} y={y - size / 10} width={size} height={size / 5} stroke={strokeColor} fill={fillColor} />
  </>
);

export const drawEllipseSvg = (x, y, size, strokeColor, fillColor = 'none') => {
  const width = size;
  const height = size / 1.5;
  return <ellipse cx={x} cy={y} rx={width / 2} ry={height / 2} stroke={strokeColor} fill={fillColor} />;
};

export const drawHeartSvg = (x, y, size, strokeColor, fillColor = 'none') => {
  const path = `
    M ${x},${y + size / 6}
    C ${x - size / 2},${y - size / 2} ${x - size * 0.7},${y} ${x},${y + size / 2}
    C ${x + size * 0.7},${y} ${x + size / 2},${y - size / 2} ${x},${y + size / 6}
  `;
  return <path d={path} stroke={strokeColor} fill={fillColor} />;
};

export const drawParallelogramRightSvg = (x, y, size, strokeColor, fillColor = 'none') => {
  const offset = size / 4;
  const points = [
    `${x - size / 2 + offset},${y - size / 2}`,
    `${x + size / 2 + offset},${y - size / 2}`,
    `${x + size / 2 - offset},${y + size / 2}`,
    `${x - size / 2 - offset},${y + size / 2}`
  ].join(' ');
  return <polygon points={points} stroke={strokeColor} fill={fillColor} />;
};

export const drawParallelogramLeftSvg = (x, y, size, strokeColor, fillColor = 'none') => {
  const offset = size / 4;
  const points = [
    `${x - size / 2 - offset},${y - size / 2}`,
    `${x + size / 2 - offset},${y - size / 2}`,
    `${x + size / 2 + offset},${y + size / 2}`,
    `${x - size / 2 + offset},${y + size / 2}`
  ].join(' ');
  return <polygon points={points} stroke={strokeColor} fill={fillColor} />;
};

export const drawOctagonSvg = (x, y, size, strokeColor, fillColor = 'none') => {
  const points = Array.from({ length: 8 }, (_, i) => {
    const angle = (i * 2 * Math.PI) / 8 - Math.PI / 8;
    const px = x + (size / 2) * Math.cos(angle);
    const py = y + (size / 2) * Math.sin(angle);
    return `${px},${py}`;
  }).join(' ');
  return <polygon points={points} stroke={strokeColor} fill={fillColor} />;
};

export const drawArrowSvg = (x, y, size, strokeColor, fillColor = 'none') => {
  const points = [
    `${x + size / 2},${y}`, // Right point (arrowhead)
    `${x},${y - size / 2}`, // Top point
    `${x},${y - size / 4}`, // Top inner
    `${x - size / 2},${y - size / 4}`, // Left top
    `${x - size / 2},${y + size / 4}`, // Left bottom
    `${x},${y + size / 4}`, // Bottom inner
    `${x},${y + size / 2}` // Bottom point
  ].join(' ');
  return <polygon points={points} stroke={strokeColor} fill={fillColor} />;
};

export const drawChevronRightSvg = (x, y, size, strokeColor, fillColor = 'none') => {
  const points = [
    `${x - size / 2},${y - size / 2}`, // Top-left
    `${x},${y}`, // Center
    `${x - size / 2},${y + size / 2}` // Bottom-left
  ].join(' ');
  return <polygon points={points} stroke={strokeColor} fill={fillColor} />;
};

export const drawChevronLeftSvg = (x, y, size, strokeColor, fillColor = 'none') => {
  const points = [
    `${x + size / 2},${y - size / 2}`, // Top-right
    `${x},${y}`, // Center
    `${x + size / 2},${y + size / 2}` // Bottom-right
  ].join(' ');
  return <polygon points={points} stroke={strokeColor} fill={fillColor} />;
};

export const drawDotSvg = (x, y, size, strokeColor, fillColor = 'none') => {
  const radius = size / 6; // Make the dot smaller than other icons
  return <circle cx={x} cy={y} r={radius} stroke={strokeColor} fill={fillColor} />;
};

// Additional directional arrows - matching the original arrow proportions
export const drawArrowUpSvg = (x, y, size, strokeColor, fillColor = 'none') => {
  const points = [
    `${x},${y - size / 2}`, // Top point
    `${x + size / 2},${y}`, // Right point
    `${x + size / 4},${y}`, // Right inner
    `${x + size / 4},${y + size / 2}`, // Right bottom
    `${x - size / 4},${y + size / 2}`, // Left bottom
    `${x - size / 4},${y}`, // Left inner
    `${x - size / 2},${y}` // Left point
  ].join(' ');
  return <polygon points={points} stroke={strokeColor} fill={fillColor} />;
};

export const drawArrowDownSvg = (x, y, size, strokeColor, fillColor = 'none') => {
  const points = [
    `${x},${y + size / 2}`, // Bottom point
    `${x + size / 2},${y}`, // Right point
    `${x + size / 4},${y}`, // Right inner
    `${x + size / 4},${y - size / 2}`, // Right top
    `${x - size / 4},${y - size / 2}`, // Left top
    `${x - size / 4},${y}`, // Left inner
    `${x - size / 2},${y}` // Left point
  ].join(' ');
  return <polygon points={points} stroke={strokeColor} fill={fillColor} />;
};

export const drawArrowLeftSvg = (x, y, size, strokeColor, fillColor = 'none') => {
  const points = [
    `${x - size / 2},${y}`, // Left point
    `${x},${y - size / 2}`, // Top point
    `${x},${y - size / 4}`, // Top inner
    `${x + size / 2},${y - size / 4}`, // Right top
    `${x + size / 2},${y + size / 4}`, // Right bottom
    `${x},${y + size / 4}`, // Bottom inner
    `${x},${y + size / 2}` // Bottom point
  ].join(' ');
  return <polygon points={points} stroke={strokeColor} fill={fillColor} />;
};

// Rename the original arrow function to be the right arrow
export const drawArrowRightSvg = drawArrowSvg;

export const iconOptions = [
  { label: '', value: '', draw: null },
  { label: 'Circle', value: 'circle', draw: drawCircleSvg },
  { label: 'Square', value: 'square', draw: drawSquareSvg },
  { label: 'Triangle', value: 'triangle', draw: drawTriangleSvg },
  { label: 'Star', value: 'star', draw: drawStarSvg },
  { label: 'Diamond', value: 'diamond', draw: drawDiamondSvg },
  { label: 'X', value: 'x', draw: drawXSvg },
  { label: 'Hexagon', value: 'hexagon', draw: drawHexagonSvg },
  { label: 'Pentagon', value: 'pentagon', draw: drawPentagonSvg },
  { label: 'Cross', value: 'cross', draw: drawCrossSvg },
  { label: 'Ellipse', value: 'ellipse', draw: drawEllipseSvg },
  { label: 'Heart', value: 'heart', draw: drawHeartSvg },
  { label: 'Parallelogram Right', value: 'parallelogramRight', draw: drawParallelogramRightSvg },
  { label: 'Parallelogram Left', value: 'parallelogramLeft', draw: drawParallelogramLeftSvg },
  { label: 'Octagon', value: 'octagon', draw: drawOctagonSvg },
  { label: 'Arrow Up', value: 'arrowUp', draw: drawArrowUpSvg },
  { label: 'Arrow Down', value: 'arrowDown', draw: drawArrowDownSvg },
  { label: 'Arrow Left', value: 'arrowLeft', draw: drawArrowLeftSvg },
  { label: 'Arrow Right', value: 'arrow', draw: drawArrowSvg },
  { label: 'Chevron Right', value: 'chevronRight', draw: drawChevronRightSvg },
  { label: 'Chevron Left', value: 'chevronLeft', draw: drawChevronLeftSvg },
  { label: 'Dot', value: 'dot', draw: drawDotSvg }
];

export function drawIconSvg(icon, x, y, size, strokeColor, fillColor) {
  const option = iconOptions.find((option) => option.value === icon);
  return option ? option.draw(x, y, size, strokeColor, fillColor) : null;
}

export function getIconColor(color) {
  if (!color) return '#f3f3f3';
  const tc = tinycolor(color);
  return tc.isLight() ? 'black' : 'white';
}

export const renderIconSvg = (icon, iconColor, isSolid) => {
  const drawFunction = iconOptions.find((option) => option.value === icon)?.draw;
  if (!drawFunction) return null;

  iconColor = getIconColor(iconColor);
  let fillColor = isSolid ? iconColor : 'none';
  return drawFunction(5, 5, 6, iconColor, fillColor);
};
